(() => {
  const page = document.querySelector('[data-bto-catalog]');
  if (!page) return;
  const sections = [...page.querySelectorAll('[data-catalog-section]')].map(element => ({
    element, grid: element.querySelector('[data-catalog-grid]'),
    cards: [...element.querySelectorAll('[data-catalog-card]')],
    count: element.querySelector('[data-catalog-section-count]')
  }));
  const cards = sections.flatMap(section => section.cards);
  const search = page.querySelector('[data-catalog-search]');
  const sort = page.querySelector('[data-catalog-sort]');
  const buttons = [...page.querySelectorAll('[data-catalog-filter]')];
  const count = page.querySelector('[data-catalog-count]');
  const empty = page.querySelector('[data-catalog-empty]');
  const reset = page.querySelector('[data-catalog-reset]');
  const normalize = value => value.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  const matchesGroup = (card, value) => value === 'all' || (value === 'wholesale' ? card.dataset.range === 'wholesale' : card.dataset.category === value);
  const initial = new URL(location.href);
  let group = buttons.some(b => b.dataset.catalogFilter === initial.searchParams.get('type')) ? initial.searchParams.get('type') : 'all';
  search.value = initial.searchParams.get('q') || '';
  if ([...sort.options].some(o => o.value === initial.searchParams.get('sort_by'))) sort.value = initial.searchParams.get('sort_by');
  const refine = page.querySelector('[data-catalog-refine]');
  const compact = matchMedia('(max-width:700px)');
  refine.open = !compact.matches || group !== 'all' || sort.value !== 'catalog';
  compact.addEventListener('change', () => { refine.open = !compact.matches; });
  buttons.forEach(button => {
    button.querySelector('span').textContent = String(cards.filter(card => matchesGroup(card, button.dataset.catalogFilter)).length);
  });
  function render(updateUrl = true) {
    const terms = normalize(search.value).split(' ').filter(Boolean);
    let shown = 0;
    sections.forEach(section => {
      let sectionShown = 0;
      section.cards.forEach(card => {
        const visible = matchesGroup(card, group) && terms.every(term => normalize(card.dataset.search).includes(term));
        card.hidden = !visible;
        if (visible) sectionShown++;
      });
      section.cards.slice().sort((a, b) => {
        const byName = a.dataset.title.localeCompare(b.dataset.title, 'en', {sensitivity:'base'});
        if (sort.value === 'title-descending') return -byName;
        if (sort.value === 'price-ascending') return Number(a.dataset.price) - Number(b.dataset.price) || byName;
        if (sort.value === 'price-descending') return Number(b.dataset.price) - Number(a.dataset.price) || byName;
        return byName;
      }).forEach(card => section.grid.appendChild(card));
      section.element.hidden = sectionShown === 0;
      section.count.textContent = `${sectionShown} ${sectionShown === 1 ? 'product' : 'products'}`;
      shown += sectionShown;
    });
    buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.catalogFilter === group)));
    count.textContent = `${shown} of ${cards.length} products${group === 'all' && !terms.length ? ' · retail & wholesale' : ''}`;
    empty.hidden = shown > 0;
    reset.hidden = group === 'all' && !search.value && sort.value === 'catalog';
    if (updateUrl) {
      const url = new URL(location.href);
      for (const [key, value, fallback] of [['q', search.value.trim(), ''], ['type', group, 'all'], ['sort_by', sort.value, 'catalog']]) {
        if (value === fallback) url.searchParams.delete(key); else url.searchParams.set(key, value);
      }
      history.replaceState(null, '', url);
    }
  }
  search.addEventListener('input', () => render());
  sort.addEventListener('change', () => render());
  buttons.forEach(button => button.addEventListener('click', () => { group = button.dataset.catalogFilter; render(); }));
  reset.addEventListener('click', () => { group = 'all'; search.value = ''; sort.value = 'catalog'; render(); search.focus(); });
  page.querySelector('[data-catalog-empty-reset]').addEventListener('click', () => reset.click());
  page.querySelectorAll('[data-catalog-jump]').forEach(link => link.addEventListener('click', () => {
    // Keep both sections together; clear filters so the requested section is visible.
    group = 'all'; search.value = ''; render();
    const section = sections.find(item => item.element.dataset.catalogSection === link.dataset.catalogJump);
    section?.element.querySelector('h2').focus({preventScroll:true});
  }));
  render(false);
})();
